export default __webpack_public_path__ + "static/media/mail.247fe8eb.webp";